<header class="mb-3 main" style="display: flex;flex-direction: row;justify-content: space-between">
  <img [src]="'/assets/images/side_logo.png'" alt="Mike Zeevi"/>
  <a class="navbar-brand" href="#"><img [src]="'/assets/images/logo2.png?v=1'" alt="Mike Zeevi" style="width:450px;"/></a>
  <img [src]="'/assets/images/side_logo.png'" alt="Mike Zeevi"/>
</header>

<div style="display:flex;flex-direction:row;min-height:250px;margin-bottom:3em;">

  <div style="z-index: 5;">
    <div style="display:flex">
      <div style="position:relative;z-index: 6;">
        <button class="btn btn-primary" (click)="showFilterModal=!showFilterModal" style="cursor:pointer">Filter</button>
        <div style="width:200px;position:absolute;left:80px;top:0;border: 1px #616161 solid;background: #212121;" [hidden]="!showFilterModal">
            <div style="display: flex;flex-direction: column;height:100%;">
                <div style="max-width: 250px;padding: 1em;">
                  <div class="form-label-group" style="display: flex;justify-content: space-between">
                      <button (click)="relaodPage();" class="btn btn-default" style="background: #616161;color:#fff">Restore</button>
                      <button (click)="refreshInventory();" class="btn btn-primary">Search</button>
                  </div>

                  <h4 class="h5">Size</h4>
                  <div class="dx-fieldset d-flex" >
                    <dx-number-box width="80" #weightFrom placeholder="From..."
                    (onEnterKey)="focusByName($event, 'weightTo')"></dx-number-box>&nbsp;
                    <dx-number-box width="80" #weightTo placeholder="To..."
                    (onEnterKey)="refreshInventory()"></dx-number-box>
                  </div>

                  <h4 class="h5">Color</h4>
                  <div class="dx-fieldset d-flex">
                    <dx-select-box width="80" #colorFrom [dataSource]="colors"
                      placeholder="From..."
                      (onEnterKey)="focusByName($event, 'colorTo')"
                      valueExpr="id" displayExpr="text" [searchEnabled]="false"></dx-select-box>&nbsp;
                    <dx-select-box width="80" #colorTo [dataSource]="colors" placeholder="To..."
                    valueExpr="id"
                    displayExpr="text"
                    [searchEnabled]="false"
                    (onEnterKey)="refreshInventory()" ></dx-select-box>
                  </div>

                  <h4 class="h5">Clarity</h4>
                  <div class="dx-fieldset d-flex">
                    <dx-select-box width="80" #clarityFrom [dataSource]="clarities" placeholder="From..." valueExpr="id" displayExpr="text" [searchEnabled]="false"
                    (onEnterKey)="focusByName($event, 'clarityTo')"
                    ></dx-select-box>&nbsp;
                    <dx-select-box width="80" #clarityTo [dataSource]="clarities" placeholder="To..." valueExpr="id" displayExpr="text"
                      [searchEnabled]="false"
                      (onEnterKey)="refreshInventory()"
                      ></dx-select-box>
                  </div>
                </div>
              </div>
        </div>
      </div>
      <div class="lastupdate"><b>Inventory List</b> [Updated on <span [innerHTML]="lastUpdate"></span>]</div>
    </div>

    <dx-data-grid #gridContainer
    keyExpr="LotIDStr"
    height="500"
    [dataSource]="dataSource"
    [showBorders]="true"
    [columns]="inventoryColumns"
    [showColumnLines]="true"
    [showRowLines]="true"
    [rowAlternationEnabled]="true"
    [hoverStateEnabled]="true"
    width="900"
    ><dxo-scrolling mode="virtual" rowRenderingMode="virtual" ></dxo-scrolling>
    <dxo-selection mode="single"></dxo-selection>
    <dxo-remote-operations
    [sorting]="true"
    [paging]="true">
    </dxo-remote-operations>
    <dxo-export [enabled]="false"></dxo-export>
    <dxo-paging [pageSize]="pageSize"></dxo-paging>
    <dxo-pager [showPageSizeSelector]="false"></dxo-pager>
    <!-- <dxo-column-fixing [enabled]="true"></dxo-column-fixing> -->
    <dxi-column *ngFor="let column of inventoryColumns"
      [dataField]="column.dataField"
      [caption]="column.caption"
      [width]="column.width || 'auto'"
      [dataType]="column.dataType"
      [cellTemplate]="column.cellTemplate"
      [visible]="column.visible"
      [hidingPriority]="column.hidingPriority"
      [sortOrder]="column.sortOrder"
      [sortIndex]="column.sortIndex || null"
      [allowSorting]="column.allowSorting"
      ></dxi-column>

    <div *dxTemplate="let data of 'cellTemplate'">
      <!--select-->
      <div *ngIf="data.column.dataField==='select'" class="text-center">
          <div class="text-center">
              <dx-check-box
              [value]="checkIfChecked(data.row.data.lotid)"
              (onValueChanged)="selectItem2($event,data.row.data, data)">
          </dx-check-box>
        </div>

      </div>
      <div *ngIf="data.column.dataField === 'Weight'" class="number">
        {{data.row.data[data.column.dataField] | number: '1.2-2'}}
      </div>

      <div *ngIf="data.column.dataField === 'Depth'" class="number">
        {{data.row.data[data.column.dataField] | number: '1.1-1'}}
      </div>

      <!--lab-->
      <div *ngIf="data.column.dataField==='Lab'" class="text-center">
        <a class="blue-link" href="{{data.row.data.GnrChr2}}" target="_blank">{{data.row.data.Lab}}</a>
      </div>

      <!--segoma-->
      <!-- https://segoma.com/support.php -->
      <div *ngIf="data.column.dataField==='GnrChr1' && data.row.data.GnrChr1 !== ''" class="text-center">
        <span class="blue-link" (click)="viewVideo(data.row.data.GnrChr1)">View</span>
      </div>
    </div>
    </dx-data-grid>
  </div>

</div>

<dx-popup
    class="popup my-popup"
    [showTitle]="true"
    [dragEnabled]="true"
    [closeOnOutsideClick]="true"
    [(visible)]="isModalVisible"
    [contentTemplate]="'content'"
    (onHiding)="urlSafe=''"
    width="500"
    height="500"
    >
    <div *dxTemplate="let data of 'content'" style="height:500px;background: #fff">
      <iframe width="100%" style="width:100%;min-height: 500px;" [src]="urlSafe" scrolling="no" frameborder="0"></iframe>
      <!-- https://segoma.com/v.php?type=iframe&id=8WNVR89DZZ [src]="urlSafe"-->
    </div>
</dx-popup>

<div style="text-align: center;color: #fff">
  <p>
      <b>M.Z. Diamonds Ltd</b> ©
  </p>
  <p>
    54 Betzalel St. Ramat Gan, Israel, Yahalom building suite 1668/69
  </p>
  <p>
    <b>Tel</b>: 972-36130036  | <b>Fax</b>: 972-36130026 | <b>Mobile</b>: +972-543-978474 <a href="https://wa.me/972543978474" target="_blank"><img style="width:30px;width: 20px;margin: 0 6px;" src="http://cdn3.iconfinder.com/data/icons/social-network-30/512/social-01-512.png"/></a>| <b>Contact Person</b>: Aviv
  </p>
  <p>
    <a href="mailto:mikediam@netvision.net.il?subject=Mail From MZ-Diamonds Web Site" style="font-weight:bold">mikediam@netvision.net.il</a>
  </p>

</div>
